/* eslint-disable class-methods-use-this */
/* eslint-disable no-setter-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-return-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-cond-assign */
/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-underscore-dangle */
import type { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { pickBy } from 'lodash';
import type ViewProxy from './ViewProxy';
import type DolanProxy from './DolanProxy';
import AbstractProxy from './AbstractProxy';

interface ComponentInstanceProxyContext {
  parent?: ViewProxy | null;
  $parent?: ComponentInstanceProxy | null;
  dolan: DolanProxy;
}

interface ComponentInstanceProxy extends ComponentInstance, ComponentInstanceProxyContext {
  /* declaring properties for the class with interface merging */
}

class ComponentInstanceProxy extends AbstractProxy<ComponentInstance> {
  // This array will be mutated
  public children: ComponentInstanceProxy[] = [];

  /**
   * @deprecated
   */
  public pending_composite_finalization?: boolean;

  /**
   * @deprecated
   */
  public generate_new_ids_in_composite_finalization?: boolean;

  /**
   * @deprecated
   */
  public composite_flows?: any;

  /**
   * @deprecated
   */
  public originalId?: string;

  constructor(component: ComponentInstance, { parent, $parent, dolan }: ComponentInstanceProxyContext) {
    super();
    Object.defineProperties(this, {
      // Ensure that if $$hashKey is ever written due to incorrect use of AngularJS, the $$hashKey property becomes non-enumerable and does not end up to DOLAN
      $$hashKey: {
        value: undefined,
        enumerable: false,
        writable: true,
      },
      dolan: {
        value: dolan,
        enumerable: false,
        writable: true,
      },
      getCompositeRoot: {
        value: this.getCompositeRoot.bind(this),
        enumerable: false,
      },
      parent: {
        value: parent,
        writable: true,
        enumerable: false,
      },
      $parent: {
        value: $parent,
        writable: true,
        enumerable: false,
      },
      instances: {
        value: [],
        writable: true,
        enumerable: false,
      },
      css: {
        value: {},
        writable: true,
        enumerable: false,
      },
      pending_composite_finalization: {
        value: undefined,
        writable: true,
        enumerable: false,
      },
      generate_new_ids_in_composite_finalization: {
        value: undefined,
        writable: true,
        enumerable: false,
      },
      composite_flows: {
        value: undefined,
        writable: true,
        enumerable: false,
      },
      originalId: {
        value: undefined,
        writable: true,
        enumerable: false,
      },
    });
    // Assign all DOLAN properties to this instance as OWN ENUMERABLE properties
    this.assignProperties(component);
    // Some migrations to default values
    this.args ||= {};
    this.style ||= {};
  }

  // NOTE: Must be non-enumerable
  public get description() {
    const description = this.dolan.components.find((c) => c.name === this.name);
    if (!description) {
      throw new Error(`no component description found for ${this.name} in create`);
    }
    return description;
  }

  // NOTE: Must be non-enumerable
  public get dolanNodeType() {
    return 'Component';
  }

  // NOTE: Must be non-enumerable
  public get appVariables() {
    return this.dolan.variables;
  }

  toJSON(): ComponentInstance {
    // NOTE: As all DOLAN-related properties are OWN ENUMERABLE properties,
    // we can do the conversion to a plain object with a simple spread operation.
    // Subcomponents still need to be unwrapped from ViewProxy to plain data.
    const { style, children, ...component } = this;
    return {
      ...component,
      style: pickBy(style, (value) => value != null),
      children: children.map((c) => c.toJSON()),
    };
  }

  /**
   * Mutates the proxy instance by assigning all the given values (as own enumerable
   * properties) and cloning values as needed for mutating them later.
   */
  assignProperties({ children, css: _css, ...component }: Partial<ComponentInstance>): boolean {
    const changed = super.assignProperties(component);
    if (children) {
      return this.setChildren(children) || changed;
    }
    return changed;
  }

  protected prepareAssignedProperty<Property extends keyof ComponentInstance>(
    _propertyName: Property,
    newValue: ComponentInstance[Property],
  ): unknown {
    // All of the component properties (except children, handled separately) are immutable
    return newValue;
  }

  private setChildren(children: ComponentInstance[]): boolean {
    // Recursively build child component proxies
    let changed = false;
    const previousProxyInstances: (ComponentInstanceProxy | null)[] = this.children.slice();
    this.children.length = 0;
    children.forEach((child, index) => {
      // Check if the proxy instance already exists
      // NOTE: Re-using an instance only if both ID and `name` matches
      const previousIndex = previousProxyInstances.findIndex(
        (c) => c != null && c.id === child.id && c.name === child.name,
      );
      const existingProxyInstance = previousProxyInstances[previousIndex];
      if (existingProxyInstance) {
        // Keep this instance and update it's state
        this.children.push(existingProxyInstance);
        // Ensure that the same proxy instance is never re-used for another index, even if DOLAN is corrupted
        previousProxyInstances[previousIndex] = null;
        if (existingProxyInstance.setState(child) || index !== previousIndex) {
          changed = true;
        }
      } else {
        // Create a new view proxy instance
        this.children.push(
          new ComponentInstanceProxy(child, {
            dolan: this.dolan,
            parent: this.parent,
            $parent: this,
          }),
        );
        changed = true;
      }
    });
    // Check if there are any removed proxy instances
    return changed || previousProxyInstances.some((c) => c != null);
  }

  getCompositeRoot() {
    let parent;
    let _ref;
    parent = this.$parent;
    while (parent != null && !((_ref = parent.description) != null ? _ref.composite_json : undefined)) {
      parent = parent.$parent;
    }
    return parent;
  }
}

export default ComponentInstanceProxy;
